import Head from 'next/head';

import { Slot, createPage } from '@lib/util/templateHelpers';
import shared from '@lib/components';
const { Box, Block, Title, Textarea, Content, DocumentTitle } = shared;

import DeveloperLayout from '@/layouts/DeveloperLayout';

export default createPage('IoGamesWidget', {}, function IoGamesWidget({ className }) {
  const widgetSrc = '<iframe style="position: fixed; bottom: 40px; right: 20px; visibility: visible;" id="IOG_CP" scrolling="no" frameborder="0" width="220" height="125" src="http://viral.iogames.space"></iframe>';

  return (
    <>
      <DocumentTitle title='The iogames.space cross-promotion widget' />

      <DeveloperLayout className={className}>
        <Box>
          <Title>Cross-Promotion Widget</Title>

          <Block>
            <Content>
              <p>
                <strong>
                  Get massive traffic to your Io game by installing the iogames.space cross-promotion widget!
                </strong>
              </p>
              <p>
                The widget will promote other games on your site and other games (which have the widget) will promote your game. Every 5 minutes a new game is promoted across all widgets, so expect short burts of traffic throughout the day!
              </p>
            </Content>
          </Block>

          <hr />

          <Block>
            <Content>
              <Title size4>How does it work?</Title>
              <p>
                The widget will appear in the lower right using absolute positioning. You might need to do some CSS styling on your end to assure it appears in the right spot.
              </p>
              <p>
                Simply copy and paste the code below:
              </p>
              <p>
                <Textarea readOnly value={widgetSrc} />
              </p>
            </Content>
          </Block>

          <hr />

          <Block>
            <Content>
              <Title size4>How to Opt-In</Title>
              <p>
                  <small>NOTE: YOU MUST HAVE A GAME RATING HIGHER THAN 65 TO APPEAR IN THE WIDGET.</small>
              </p>
              <p>
                  If you you installed the widget on your game, simply check the "Cross Promotion" tick box on the game submission form. An admin will review your game to ensure the widget is properly installed. Once verified, your site will begin showing in the widget. Please not that we reserve the right to reject games for widget promotion if they don't meet quality standards. 
              </p>
            </Content>
          </Block>
        </Box>
      </DeveloperLayout>
    </>
  )
});
